// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon-right_icon__1jD8r","remove":"icon-right_remove__2gf10"};